var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1023 15.0529C17.3286 13.5668 18.103 11.6608 18.103 9.56094C18.103 4.84435 14.2629 1 9.55152 1C4.84012 1 1 4.84435 1 9.56094C1 14.2775 4.84012 18.1219 9.55152 18.1219C11.6168 18.1219 13.553 17.3789 15.0374 16.1189L21.685 22.7739C21.8463 22.9354 22.04 23 22.2336 23C22.4272 23 22.6208 22.9354 22.7822 22.7739C23.0726 22.4831 23.0726 21.9662 22.7822 21.6755L16.1023 15.0529ZM9.51925 16.5712C5.64686 16.5712 2.51669 13.4376 2.51669 9.56094C2.51669 5.68429 5.64686 2.55066 9.51925 2.55066C13.3916 2.55066 16.5218 5.68429 16.5218 9.56094C16.5218 13.4376 13.3916 16.5712 9.51925 16.5712Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilled);
export default __webpack_public_path__ + "static/media/search_filled.198e5764a1497a3d3b352122c171f720.svg";
export { ForwardRef as ReactComponent };